import { lazy } from 'react'

import { authRoles } from '../../../../../auth/authRoles'
import Loadable from '../../../../base/components/Template/Loadable/Loadable'
import { licenciaRoutesMap } from './LicenciaRoutesMap'

const AppLicencia = Loadable(lazy(() => import('./view/listado/Licencia')))

const licenciaRoutes = [
  {
    path: licenciaRoutesMap.gestion.path,
    element: <AppLicencia />,
    auth: authRoles.admin,
  },
]

export default licenciaRoutes
